import type { ProjectPhase } from '../../../shared/types';

export const SHELVES: { phase: ProjectPhase; dot: string }[] = [
  { phase: 'lead', dot: 'pd-lead' },
  { phase: 'pre-production', dot: 'pd-pre' },
  { phase: 'shoot', dot: 'pd-shoot' },
  { phase: 'post', dot: 'pd-post' },
  { phase: 'on_hold', dot: 'pd-hold' },
];

export const ACTIVE_PHASES: ProjectPhase[] = ['lead', 'pre-production', 'shoot', 'post', 'on_hold'];
